module.exports = __webpack_public_path__ + "static/img/63-3.104966e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/63-3.jpg
// module id = n00s
// module chunks = 0